import classNames from "classnames";
import DropdownMenu from "component/react-bootstrap/DropdownMenu";
import DropdownToggle from "component/react-bootstrap/DropdownToggle";
import { ChevronDown } from "lucide-react";
import PropTypes from "prop-types";
import { Component, cloneElement } from "react";
import Dropdown from "./Dropdown";
import ValidComponentChildren from "./utils/ValidComponentChildren";
import splitComponentProps from "./utils/splitComponentProps";

const propTypes = {
  ...Dropdown.propTypes,

  // Toggle props.
  title: PropTypes.node.isRequired,
  noCaret: PropTypes.bool,
  active: PropTypes.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: PropTypes.node,
};

class NavDropdown extends Component {
  isActive({
    props,
  }: any, activeKey: any, activeHref: any) {
    if (
      props.active
      || (activeKey != null && props.eventKey === activeKey)
      || (activeHref && props.href === activeHref)
    ) {
      return true;
    }

    if (

      ValidComponentChildren.some(props.children, (child: any) => this.isActive(child, activeKey, activeHref))
    ) {
      return true;
    }

    return props.active;
  }

  render() {
    const {
      title,
      activeKey,
      activeHref,
      className,
      style,
      children,
      ...props
    } = this.props;

    const active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    const [dropdownProps, toggleProps] = splitComponentProps(props, {
      propTypes: ["id", "onSelect", "onToggle"],
    });

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return (
      <Dropdown
        open={props.show}
        {...dropdownProps}
        componentClass="li"
        className={classNames(className, { active })}
        style={style}
      >

        <DropdownToggle
          {...toggleProps}
          noCaret
          className="d-flex align-items-center"
        >
          <span className="text-capitalize">{title}</span>
          <ChevronDown size={15} strokeWidth={3} className="m-l-5" />
          {/* {!this.props.show && (
            <>

              <span className="p-l-5" />

              <svg
                viewBox="0 0 1792 1792"
                preserveAspectRatio="xMidYMid meet"
                xmlns="http://www.w3.org/2000/svg"

                xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                focusable="false"
                width="calc(1 * var(--safari-root-font, 10px))"
                height="calc(1.5 * var(--safari-root-font, 10px))"
              >

                <path
                  fill="#fff"
                  d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
                />
              </svg>
            </>
          )} */}
        </DropdownToggle>

        <DropdownMenu>

          {ValidComponentChildren.map(children, (child: any) => cloneElement(child, {
            active: this.isActive(child, activeKey, activeHref),
          }))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

NavDropdown.propTypes = propTypes;

export default NavDropdown;
